'use strict';

(function () {
  'use strict';

  angular.module('msGoals').service('goalSvc', goalService);

  goalService.$inject = ['httpSvc', 'NotifyingSvc', '$q'];

  function goalService(httpSvc, NotifyingSvc, $q) {
    return {
      fetchGoals: fetchGoals,
      saveGoal: saveGoal,
      updateHabit: updateHabit,
      triggerHabit: triggerHabit,
      getHabitResponses: getHabitResponses,
      fetchGoalsAndHabits: fetchGoalsAndHabits
    };

    ///////////// Public Functions //////////////////
    function fetchGoals() {
      //NICK - follow up on tendrils
      return httpSvc.get('/apiproxy/user/goal');
    }

    function saveGoal(goal) {
      return httpSvc.post('/apiproxy/user/goal', cleanGoal(goal)).then(function (resp) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GOALS_UPDATED, {});
        return resp;
      });
    }

    function updateHabit(habit) {
      return httpSvc.post('/apiproxy/user/goal/section', cleanHabit(habit)).then(function (resp) {
        NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GOALS_UPDATED, {});
        return resp;
      });
    }

    function triggerHabit(goal) {
      return httpSvc.post('/apiproxy/user/goal/trigger', cleanGoal(goal));
    }

    function getHabitResponses() {
      return httpSvc.get('/apiproxy/user/goal/responses');
    }

    function fetchGoalsAndHabits() {
      var deferred = $q.defer();
      var goalsList;

      $q.all([fetchGoals(), getHabitResponses()]).then(function (data) {
        goalsList = data[0];
        // For each goal
        _.each(goalsList, function (g) {
          // For each habit in a goal
          _.each(g.sections, function (s) {
            // Find the responses
            var responses = _.filter(data[1], function (resp) {
              return resp.submissions[0] && s.widgets[0].id === resp.submissions[0].widgetId;
            });
            if (responses) {
              s.data = _.map(responses, function (r) {
                return {
                  datetime: moment(r.modifiedOn),
                  // This value is just for sizing. Could be anything in the range [-1,1]
                  value: 0.5
                };
              });
            } else {
              s.data = [];
            }
          });
        });
        deferred.resolve(goalsList);
      });
      return deferred.promise;
    }

    ///////////// Private Functions //////////////////

    /**
     * This function removes model updates that are not
     * part of the server entity attributes.  It deletes
     * the attributes from a shallow copy so the front end
     * model is not affected.
     * @param goal
     * @returns {*}
     */
    function cleanGoal(goal) {
      var goalCopy = angular.copy(goal);
      _.each(goalCopy.sections, function (s) {
        delete s.data;
        delete s.color;
        delete s.isCompletedRecently;
        delete s.isBlocked;
      });
      return goalCopy;
    }

    /**
     * This function removes model updates that are not
     * part of the server entity attributes.  It deletes
     * the attributes from a shallow copy so the front end
     * model is not affected.
     * @param habit
     * @returns {*}
     */
    function cleanHabit(habit) {
      var habitCopy = angular.copy(habit);
      delete habitCopy.data;
      delete habitCopy.color;
      return habitCopy;
    }
  }
})();